import axios from "axios";

const vuexData = JSON.parse(localStorage.getItem("vuex"));
const getLoggedInUserEmail = localStorage.getItem("logged_user_user_email");

const toolkitAxios = axios.create({
  baseURL: process.env.VUE_APP_TOOLKIT_BASE_URL,
  headers: {
    Employer: vuexData?.getLoggedInUser?.code,
    Contact: vuexData?.getLoggedInUser?.contact_code,
    Identifier: getLoggedInUserEmail,
    Authorization: `Bearer ${localStorage.getItem("token")}`,
    accept: "application/json",
  },
});

const engageAxios = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  headers: {
    Authorization: `Bearer ${process.env.VUE_APP_NEW_ENGAGE_BEARER_TOKEN}`,
    accept: "application/json",
    channel: process.env.VUE_APP_ENGAGE_TOKEN,
  },
});

export { toolkitAxios, engageAxios };
